<!-- 员工管理 -->
<template>
  <div class="basicStyle">
    <div class="bg_fff">
      <div class="querySearch">
        <div class="searchItem">
          <span>用户信息</span>
          <el-input
            v-model="queryInfo.keyword"
            clearable
            size="small"
            placeholder="请输入登录账号、手机号查询"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>状态</span>
          <el-select
            v-model="queryInfo.status"
            size="small"
            class="w200Select" 
          >
            <el-option
              v-for="item in status_list"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div> 
        <div class="searchItem">
          <span>角色</span> 
          <el-select
            v-model="queryInfo.role"
            placeholder="请选择角色选项"
            size="mini"
          > 
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="(item, index) in roleListAll"
              :key="index"
              :label="item.value"
              :value="item.key"
            ></el-option>
          </el-select> 
        </div>  
        <MyButton
          value="搜索"
          size="medium"
          icon="el-icon-search"
          type="1"
          @click="queryTable('search')"
        ></MyButton>
        <MyButton
          value="重置"
          size="medium"
          type="2"
          @click="resetQuery"
        ></MyButton>
      </div>
      <div class="addInfo">
        <!-- <el-button type="primary" size="small" @click="viewDetail"
        >新增</el-button
      > -->
        <MyButton
          value="新增"
          size="medium"
          icon="el-icon-folder-add"
          type="1"
          @click="viewDetail"
        ></MyButton>
      </div>
      <div class="table">
        <TableComponents :columns="columns" :tableData="tableList">
          <template slot="operation" slot-scope="{ row }">
            <div v-if="row.status == 2">
              该员工已删除
            </div>
            <div v-else> 
              <span
                class="operationItem"
                @click="viewDetail(row)"
                v-if="mainInfo.id !== row.id"
                >编辑</span
              >
              <el-popover
                placement="bottom"
                trigger="hover"
                popper-class="accountManage"
              >
                <div>
                  <div @click="copy(row)" class="hoverRed">复制账号密码</div>
                  <div @click="editCodeDia(row)" class="hoverRed">修改密码</div>
                  <div @click="resetCode(row)" class="hoverRed">重置密码</div>
                  <div
                    @click="deleteData(row)"
                    v-if="mainInfo.id !== row.id"
                    class="hoverRed"
                  >
                    删除
                  </div>
                </div>
                <span slot="reference" class="operationItem">账号管理</span>
              </el-popover>
            </div>
          </template>
        </TableComponents>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.page"
          :page-sizes="[10, 30, 50, 80]"
          :page-size="queryInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryInfo.total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 新增编辑弹窗 -->
    <el-dialog
      :title="dialogType"
      :visible.sync="addFormShow"
      class="formDialog"
      width="500px"
    >
      <el-form
        :model="userInfo"
        :rules="rules"
        ref="userInfoForm"
        label-width="100px"
      >
        <el-form-item label="手机号：" prop="mobile">
          <el-input
            v-model="userInfo.mobile"
            placeholder="请输入手机号"
            size="mini"
            :disabled="formReqired"
          ></el-input>
        </el-form-item>
        <el-form-item label="真实姓名：" prop="realname">
          <el-input
            v-model="userInfo.realname"
            maxlength="6"
            placeholder="请输入真实姓名(2-6个汉字）"
            size="mini"
            :disabled="formReqired"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色：" prop="role" class="roleStyle">
          <el-select
            v-model="userInfo.role"
            placeholder="请选择角色选项"
            size="mini"
          >
            <el-option
              v-for="(item, index) in roleList"
              :key="index"
              :label="item.value"
              :value="item.key"
            ></el-option>
          </el-select>
          <el-popover placement="right" trigger="click">
            <el-table
              :data="roleList"
              style="font-size: 12px"
              header-cell-class-name="tableHeader"
              border
            >
              <el-table-column
                align="center"
                property="value"
                label="角色名称"
                width="100"
              ></el-table-column>
              <el-table-column
                align="center"
                property="flag"
                label="权限说明"
                width="200"
              ></el-table-column>
            </el-table>
            <el-button slot="reference">
              <img src="../../../assets/img/问号.png" alt="" />
            </el-button>
          </el-popover>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            style="width: 250px"
            v-model="userInfo.remark"
            placeholder="请输入备注"
            size="mini"
            maxlength="50"
            show-word-limit
            type="textarea"
          ></el-input>
        </el-form-item>
        <el-form-item label="外呼号码：">
          <el-input
            style="width: 250px"
            v-model="userInfo.call_phone"
            placeholder="请输入外呼号码"
            size="mini"
            maxlength="11"
            show-word-limit
          ></el-input>
          <el-button type="text" @click="kefuDialogVisible = true"
            ><i class="el-icon-question el-icon--right"></i
          ></el-button>
        </el-form-item>
        <el-form-item label="">
          <el-checkbox
            v-model="userInfo.is_open_show_mobile"
            :true-label="1"
            :false-label="0"
            @change="$forceUpdate()"
            >开通客户号码可视权限（不开通默认客户手机号码<br />
            中间四位数隐藏）</el-checkbox
          >
        </el-form-item>
        <el-form-item label="状态：">
          <el-radio-group v-model="userInfo.status" size="mini">
            <el-radio-button :label="1">启用</el-radio-button>
            <el-radio-button :label="0">禁用</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addUser('userInfoForm')" size="mini"
          >确 定</el-button
        >
        <el-button @click="addFormShow = false" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 修改密码弹窗 -->
    <el-dialog
      title="修改密码"
      :visible.sync="resetCodeShow"
      class="formDialog"
      width="500px"
    >
      <el-form
        :model="codeInfo"
        :rules="codeRules"
        ref="codeInfoForm"
        label-width="120px"
      >
        <el-form-item label="输入新密码：" prop="new_password">
          <el-input
            v-model="codeInfo.new_password"
            placeholder="六位数以上"
            size="mini"
            :disabled="formReqired"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="确认新密码：" prop="new_password_confirmation">
          <el-input
            v-model="codeInfo.new_password_confirmation"
            placeholder="请确认密码"
            size="mini"
            :disabled="formReqired"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editCode('codeInfoForm')" size="mini"
          >确 定</el-button
        >
        <el-button @click="resetCodeShow = false" size="mini">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 计费说明弹窗 -->
    <el-dialog
      title="外呼主叫号码说明"
      :visible.sync="kefuDialogVisible"
      class="formDialog"
      width="500px"
    >
      <div v-html="notice"></div>
    </el-dialog>
  </div>
</template>

<script>
import employApi from "@/api/employ.js";
import commonApi from "@/api/common.js";
import { clearObj, copyToClip } from "@/utils/index.js";
import TableComponents from "@/components/TableComponents.vue";
import MyButton from "@/components/MyButton.vue";
export default {
  name: "employeesManage",
  components: {
    TableComponents,
    MyButton,
  },
  data() {
    var confirmPasswordVerify = (_, value, callback) => {
      if (!value) {
        return callback(new Error("确认密码不能为空"));
      } else if (value != this.codeInfo.new_password) {
        return callback(new Error("两次密码输入需一致"));
      } else {
        callback();
      }
    };
    return {
      queryInfo: {
        limit: 10,
        page: 1,
        total: 0,
        keyword: "",
        account_id: "",
        status: 1,
        role: "",
      },
      columns: [
        //列数据
        { label: "员工ID", prop: "id" },
        { label: "APP邀请码", prop: "invite_code" },
        { label: "登录账号", prop: "username" },
        { label: "真实姓名", prop: "realname" },
        { label: "手机号", prop: "mobile" },
        { label: "外呼主叫号码", prop: "call_phone" },
        { label: "角色", prop: "role_name" },
        { label: "状态", prop: "status_name" },
        { label: "创建人", prop: "create_user" },
        { label: "创建时间", prop: "created_at" },
        { label: "更新人", prop: "update_user" },
        { label: "更新时间", prop: "updated_at" },
        { label: "备注", prop: "employRemark" },
        { label: "创建学员数量", prop: "create_student_total" }, 
        { label: "操作", prop: "operation" },
      ],
      tableList: [],
      status_list:[],
      // 新增编辑表单数据
      addFormShow: false,
      userInfo: {
        mobile: "",
        realname: "",
        role: "",
        remark: "",
        status: 1,
        id: 0,
        call_phone: "",
      },
      rules: {
        mobile: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        realname: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
          {
            validator: function (rule, value, callback) {
              if (/^[\u4e00-\u9fa5]+$/.test(value) == false) {
                callback(new Error("请输入2-6个汉字"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "change",
          },
          { min: 2, max: 6, message: "请输入2-6个汉字", trigger: "change" },
        ],
        role: [{ required: true, message: "请选择角色", trigger: "blur" }],
      },
      // 编辑时的禁用字段
      formReqired: false,

      // 重置密码弹窗
      resetCodeShow: false,
      codeInfo: {
        new_password: "",
        new_password_confirmation: "",
      },
      codeRules: {
        new_password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            min: 6,
            max: 15,
            message: "密码必须使用6-15位字符",
            trigger: "change",
          },
        ],
        new_password_confirmation: [
          { required: true, validator: confirmPasswordVerify, trigger: "blur" },
        ],
      },
      kefuDialogVisible: false,
      notice: "",
      roleList: [],
      roleListAll: [],
    };
  },
  computed: {
    dialogType() {
      //  this.userInfo.id,this.userInfo.id?'编辑':'新增');
      return this.userInfo.id ? "编辑" : "新增";
    },
    // roleList() {
    //   return this.$store.state.user.roleList;
    // },
    mainInfo() {
      return this.$store.state.user.userInfo;
    },
  },
  watch: {
    addFormShow: {
      handler(_newVal) {
        if (!_newVal) {
          // Object.keys(this.userInfo).forEach(key =>{
          //   if(typeof this.userInfo[key] == 'string'){
          //     this.userInfo[key] = ''
          //   }else if(typeof this.userInfo[key] == 'number'){
          //     this.userInfo[key] = 1
          //   }
          // });
          (this.userInfo = {
            mobile: "",
            realname: "",
            role: "",
            remark: "",
            status: 1,
            id: 0,
            call_phone: "",
          }),
            this.$refs["userInfoForm"].resetFields();
          this.formReqired = false;
        }
      },
    },
    resetCodeShow: {
      handler(_newVal) {
        if (!_newVal) {
          clearObj(this.codeInfo);
          this.$refs["codeInfoForm"].resetFields();
        }
      },
    },
  },
  created() {
    console.log("aaa", this.$route.query);
    if (this.$route.query.id) {
      this.queryInfo.account_id = this.$route.query.id;

      this.queryTable("search");
    }
    this.getDic();
    this.queryTable();
  },
  methods: {
    getDic() {
      commonApi.getDictionaries({ names: "outwardcal,roleconfiguration" }).then((res) => {
        if (res.data && res.data.outwardcal.length > 0) {
          res.data.outwardcal.forEach((item) => { 
            if (item.key == "sstructions") {
              this.notice = item.value;
            }
          });
        }  
        // if (res.data && res.data.roleconfiguration.length > 0) {
        //   this.roleList = []
        //   this.roleListAll = []
        //   res.data.roleconfiguration.forEach((item) => {
        //     if(item.key != 'admin'){
        //       this.roleList.push(item)
        //     }
        //     this.roleListAll.push(item)
        //   })
        // } 
      });
    },
    // 列表数据
    async queryTable(_type) {
      if (_type) {
        this.queryInfo.page = 1;
      }
      const res = await employApi.employList(this.queryInfo);
      //  res);
      if (res.code == 200) {
        this.queryInfo.total = res.data.total;
        this.tableList = res.data.data;
        this.tableList.forEach((item, index) => {
          this.tableList[index].sortId =
            (this.queryInfo.page - 1) * this.queryInfo.limit + (index + 1);
          this.tableList[index].employRemark = item.remark;
          // employRemark
        });

        this.status_list = res.data.status_list; 

        
        if (res.data && res.data.role_list.length > 0) {
          this.roleList = []
          this.roleListAll = []
          res.data.role_list.forEach((item) => {
            if(item.key != 'admin'){
              this.roleList.push(item)
            }
            this.roleListAll.push(item)
          })
        } 
      } else {
        this.$message.error(res.message);
      }
    },
    // 打开弹窗
    viewDetail(row) {
      //  row);
      if (row.id) {
        Object.assign(this.userInfo, row);
        this.formReqired = true;
      }
      this.addFormShow = true;
    },
    // 添加｜｜修改数据
    addUser(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res;
          if (this.userInfo.id) {
            res = await employApi.employEdit(this.userInfo);
          } else {
            let _obj = {};
            Object.assign(_obj, this.userInfo);
            delete _obj.id;
            res = await employApi.employAdd(_obj);
          }

          if (res.code == 200) {
            if (!this.userInfo.id) {
              this.$alert("新增账号成功", "", {
                confirmButtonText: "复制账号密码",
                center: true,
                customClass: "customCopy",
                callback: (action) => {
                  // this.copy(this.tableList[0])
                  //  'action----',action);
                  if (action == "confirm") {
                    this.$message.success("复制成功");
                    copyToClip(
                      `登录账号：${res.data.username};密码：${res.data.password}`
                    );
                  }
                },
              });
            } else {
              this.$message.success(`${this.dialogType}成功`);
            }
            this.queryTableMe();
            await this.queryTable();
            this.addFormShow = false;
          } else {
            this.$message.error(res.message);
          }
        } else {
          //  'error submit!!');
          return false;
        }
      });
    },
    // 更新个人信息
    async queryTableMe() {
      const userInfoData = await commonApi.tobMe();
      let _info = userInfoData.data;
      if (userInfoData.data.password) {
        delete _info.password;
      }
      this.$store.commit("user/SET_USER_INFO", _info);
    },
    // 一键复制功能
    copy(row) {
      copyToClip(`登录账号：${row.username};密码：${row.password}`);
      this.$message.success("复制成功！");
    },
    // 删除数据
    deleteData(row) {
      this.$confirm("此操作将永久删除该员工, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          employApi.employDelete({ id: row.id }).then((res) => {
            if (res.code == 200) {
              this.$message.success("删除成功");
              this.queryTable();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 设置新密码
    editCodeDia(row) {
      this.resetCodeShow = true;
      Object.assign(this.codeInfo, row);
    },
    editCode(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const res = await employApi.employEdit(this.codeInfo);
          if (res.code == 200) {
            this.$message.success(res.message);
            this.resetCodeShow = false;
            this.queryTable();
          } else {
            this.$message.error(res.message);
          }
        } else {
          //  'error submit!!');
          return false;
        }
      });
    },
    // 重置密码
    resetCode(row) {
      let _password = row.default_password ? row.default_password : "1234567";
      this.$confirm(
        `是否将用户【${row.username}】的密码设置为初始密码【${_password}】`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        }
      )
        .then(async () => {
          let _obj = row;
          Object.assign(_obj, {
            new_password: _password,
            new_password_confirmation: _password,
          });
          const res = await employApi.employEdit(_obj);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "重置成功!",
            });
            this.queryTable();
          } else {
            this.$message.error(res.code);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消重置",
          });
        });
    },
    // 分页
    handleSizeChange(e) {
      //  e);
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.queryInfo.page = e;
      this.queryTable();
    },
    // 重置
    resetQuery() {
      this.queryInfo = {
        limit: 10,
        page: 1,
        total: 0,
        keyword: "",
        status: 1,
        role: "",
      };
      this.queryTable();
    },
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  span {
    display: inline-block;
  }
  .querySearch {
    .searchItem {
      display: inline-block;
      margin-right: 50px;
      span {
        margin-right: 10px;
        font-size: 14px;
        padding: 5px 0;
      }
      /deep/ .el-input {
        width: 250px;
        padding: 5px 0;
      }
    }
    /deep/ .el-button--primary {
      // margin-left: 50px;
    }
  }
  .addInfo {
    margin: 10px 0;
  }

  // 表格数据
  .table {
    // min-height: calc(100vh - 330px);
  }
  .operationItem {
    display: inline-block;
    margin: 0 5px;
    cursor: pointer;
    color: rgb(87, 87, 239);
  }
  .operationItem:hover {
    color: red;
  }

  // 分页
  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px;
  }

  /deep/ .formDialog {
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .dialog-footer {
      text-align: center;
    }
    .roleStyle {
      .el-form-item__content {
        display: flex;
        align-items: center;
        .el-form-item__content {
          margin-left: 0 !important;
        }
        img {
          width: 20px;
          height: 20px;
          margin-left: 10px;
          cursor: pointer;
        }
        .el-button {
          border: none;
          padding-left: 5px;
        }
        .el-button:focus,
        .el-button:hover {
          background-color: #fff;
        }
      }
    }
  }

  /deep/.el-checkbox__input {
    vertical-align: top;
    margin-top: 10px;
  }
}
</style>
